module.exports = __webpack_public_path__ + "c6236fdcf97282a5e2b10343cc67c480.svg";